import React from 'react'
import { Control } from 'react-redux-form'
import styled, { css } from 'styled-components'
import { PlaceholderStyle } from 'components/form-components/styled-text-input'
import { ThemeSpace } from 'theme/spaces'

export interface StyledTextAreaProps {
  model?: string
  type?: string
  autoComplete?: string
  children?: React.ReactNode | React.ReactNode[]
  className?: string
  content?: string
  maxLength?: number
  placeholder?: string
  readOnly?: boolean
  onChange?: any
  updateOn?: any
  validateOn?: any
  validators?: any
  rows?: number
  maxWidth?: ThemeSpace
}

export const TextAreaStyle = css<{
  $maxWidth?: ThemeSpace
  readOnly?: boolean
}>`
  background-color: ${({ theme }) => theme.color.grey07};
  border: none;
  color: ${({ theme, readOnly }) => readOnly ? theme.color.grey90 : theme.color.bodyText};
  height: auto;
  min-height: ${({ theme }) => theme.space.s40};
  line-height: ${({ theme }) => theme.space.s24};
  width: ${({ $maxWidth, theme }) =>
    $maxWidth ? theme.space[$maxWidth] : '100%'};
  max-width: ${({ $maxWidth, theme }) =>
    $maxWidth ? theme.space[$maxWidth] : '100%'};
  min-width: ${({ theme }) => theme.space.s320};
  padding: ${({ theme }) => theme.space.s8} ${({ theme }) => theme.space.s16};
  outline: none;
  overflow: auto;

  cursor: ${({ readOnly }) => (readOnly ? 'not-allowed' : 'auto')};

  /* Chrome, Firefox, Opera, Safari 10.1+ */
  ::placeholder {
    ${PlaceholderStyle};
  }

  /* Microsoft Edge */
  ::-ms-input-placeholder {
    ${PlaceholderStyle};
  }
`

const TextAreaControlField = styled(Control.textarea)`
  ${TextAreaStyle};
`

const TextAreaField = styled.textarea`
  ${TextAreaStyle};
`

export const StyledTextArea = ({
  model,
  type = 'text',
  autoComplete,
  children,
  className,
  content,
  maxLength,
  placeholder,
  readOnly = false,
  onChange,
  updateOn = 'change',
  validateOn = 'change',
  validators,
  maxWidth,
  rows,
  ...props
}: StyledTextAreaProps) => {
  if (model) {
    return (
      <TextAreaControlField
        {...props}
        model={model}
        type={type}
        autoComplete={autoComplete}
        className={className}
        content={content}
        maxLength={maxLength}
        placeholder={placeholder}
        readOnly={readOnly}
        onChange={onChange}
        aria-label={model}
        updateOn={updateOn}
        validateOn={validateOn}
        validators={validators}
        rows={rows}
        $maxWidth={maxWidth}
      />
    )
  }
  return (
    <>
      <TextAreaField
        {...props}
        autoComplete={autoComplete}
        className={className}
        maxLength={maxLength}
        aria-label={model}
        placeholder={placeholder}
        readOnly={readOnly}
        onChange={onChange}
        rows={rows}
        $maxWidth={maxWidth}
      />
      {children}
    </>
  )
}
